import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './XlabsCompare.css';

/**
 * Side-by-side A ‖ B architecture compare with DIFF highlights.
 * See docs/XLABS_ARCHITECTURE.md
 */

function Diff({ axis, choice, note }) {
  return (
    <div className="diff">
      <span className="diff-label">Diff</span>
      <div className="axis">{axis}</div>
      <div className="choice">
        {choice}
        {note ? <small>{note}</small> : null}
      </div>
    </div>
  );
}

function Same({ axis, text }) {
  return (
    <div className="same">
      <div className="axis">{axis}</div>
      {text}
    </div>
  );
}

function XlabsFlow() {
  return (
    <svg className="flow-wrap svg" viewBox="0 0 1200 460" xmlns="http://www.w3.org/2000/svg" fontFamily="Inter Tight, sans-serif">
      <defs>
        <marker id="cmp-a" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="6" markerHeight="6" orient="auto">
          <path d="M0,0 L10,5 L0,10 z" fill="#0a0a0a" />
        </marker>
        <marker id="cmp-a-g" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="6" markerHeight="6" orient="auto">
          <path d="M0,0 L10,5 L0,10 z" fill="#047857" />
        </marker>
      </defs>
      <g fontSize="10" fill="#a3a3a3" letterSpacing="1.2">
        <text x="20" y="40">UI</text>
        <text x="20" y="130">REDUX</text>
        <text x="20" y="220">DOMAIN</text>
        <text x="20" y="310">SPECKLE</text>
        <text x="20" y="400">RENDER</text>
      </g>
      <g stroke="#e5e5e5" strokeDasharray="2 4">
        <line x1="80" y1="60" x2="1180" y2="60" />
        <line x1="80" y1="150" x2="1180" y2="150" />
        <line x1="80" y1="240" x2="1180" y2="240" />
        <line x1="80" y1="330" x2="1180" y2="330" />
      </g>
      <g fontSize="12">
        <rect x="100" y="20" width="160" height="40" fill="#fff" stroke="#0a0a0a" />
        <text x="180" y="36" textAnchor="middle" fontWeight="600">Slider · width</text>
        <text x="180" y="51" textAnchor="middle" fill="#737373" fontSize="10">4.0 → 4.6m</text>
        <rect x="290" y="20" width="160" height="40" fill="#fffbeb" stroke="#b45309" />
        <text x="370" y="36" textAnchor="middle" fontWeight="600" fill="#b45309">SYNC · 142ms</text>
        <text x="370" y="51" textAnchor="middle" fill="#b45309" fontSize="10">Speckle RTT</text>
        <rect x="290" y="110" width="170" height="40" fill="#0a0a0a" />
        <text x="375" y="126" textAnchor="middle" fontWeight="600" fill="#fff">applyPatch()</text>
        <text x="375" y="141" textAnchor="middle" fill="#a3a3a3" fontSize="10" fontFamily="JetBrains Mono">/dimensions/width</text>
        <rect x="490" y="200" width="170" height="40" fill="#fff" stroke="#0a0a0a" />
        <text x="575" y="216" textAnchor="middle" fontWeight="600">invalidate()</text>
        <text x="575" y="231" textAnchor="middle" fill="#737373" fontSize="10">dirty graph</text>
        <rect x="690" y="200" width="180" height="40" fill="#fff" stroke="#0a0a0a" />
        <text x="780" y="216" textAnchor="middle" fontWeight="600">generateDescriptors()</text>
        <text x="780" y="231" textAnchor="middle" fill="#737373" fontSize="10">→ meshes</text>
        <rect x="690" y="290" width="180" height="40" fill="#ecfdf5" stroke="#047857" />
        <text x="780" y="306" textAnchor="middle" fontWeight="600" fill="#047857">SpeckleAdapter.commit</text>
        <text x="780" y="321" textAnchor="middle" fill="#047857" fontSize="10" opacity="0.7">branches/main</text>
        <rect x="900" y="290" width="160" height="40" fill="#ecfdf5" stroke="#047857" />
        <text x="980" y="306" textAnchor="middle" fontWeight="600" fill="#047857">Speckle server</text>
        <text x="980" y="321" textAnchor="middle" fill="#047857" fontSize="10" opacity="0.7">graphql · ws</text>
        <rect x="900" y="380" width="160" height="40" fill="#ecfdf5" stroke="#047857" />
        <text x="980" y="396" textAnchor="middle" fontWeight="600" fill="#047857">@speckle/viewer</text>
        <text x="980" y="411" textAnchor="middle" fill="#047857" fontSize="10" opacity="0.7">load(commit)</text>
        <rect x="1090" y="20" width="90" height="40" fill="#fff" stroke="#0a0a0a" />
        <text x="1135" y="36" textAnchor="middle" fontWeight="600">readouts</text>
        <text x="1135" y="51" textAnchor="middle" fill="#737373" fontSize="10">cost · BOM</text>
      </g>
      <g fill="none" stroke="#0a0a0a" strokeWidth="1.2" markerEnd="url(#cmp-a)">
        <path d="M180,60 L180,90 L290,130" />
        <path d="M375,150 L375,180 L575,200" />
        <path d="M660,220 L690,220" />
        <path d="M780,240 L780,290" />
        <path d="M780,330 L780,360 L900,400" />
      </g>
      <g fill="none" stroke="#047857" strokeWidth="1.2" markerEnd="url(#cmp-a-g)" strokeDasharray="4 3">
        <path d="M870,310 L900,310" />
        <path d="M980,330 L980,380" />
        <path d="M1060,400 L1100,400 L1135,60" />
      </g>
    </svg>
  );
}

function ConstruxFlow() {
  return (
    <svg className="flow-wrap svg" viewBox="0 0 1200 520" xmlns="http://www.w3.org/2000/svg" fontFamily="Inter Tight, sans-serif">
      <defs>
        <marker id="cmp-b" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="6" markerHeight="6" orient="auto">
          <path d="M0,0 L10,5 L0,10 z" fill="#0a0a0a" />
        </marker>
        <marker id="cmp-b-blue" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="6" markerHeight="6" orient="auto">
          <path d="M0,0 L10,5 L0,10 z" fill="#1d4ed8" />
        </marker>
        <marker id="cmp-b-g" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="6" markerHeight="6" orient="auto">
          <path d="M0,0 L10,5 L0,10 z" fill="#047857" />
        </marker>
      </defs>
      <g fontSize="10" fill="#a3a3a3" letterSpacing="1.2">
        <text x="20" y="40">UI</text>
        <text x="20" y="120">STATE</text>
        <text x="20" y="200">ADAPTERS</text>
        <text x="20" y="290">RENDER</text>
        <text x="20" y="380">EXTERNALS</text>
        <text x="20" y="470">OPTIONAL</text>
      </g>
      <g stroke="#e5e5e5" strokeDasharray="2 4">
        <line x1="90" y1="55" x2="1180" y2="55" />
        <line x1="90" y1="135" x2="1180" y2="135" />
        <line x1="90" y1="215" x2="1180" y2="215" />
        <line x1="90" y1="305" x2="1180" y2="305" />
        <line x1="90" y1="395" x2="1180" y2="395" />
      </g>
      <g fontSize="12">
        <rect x="100" y="18" width="170" height="40" fill="#fff" stroke="#0a0a0a" />
        <text x="185" y="34" textAnchor="middle" fontWeight="600">Address · Load</text>
        <text x="185" y="49" textAnchor="middle" fill="#737373" fontSize="10">Places → geocode</text>
        <rect x="300" y="18" width="170" height="40" fill="#fffbeb" stroke="#b45309" />
        <text x="385" y="34" textAnchor="middle" fontWeight="600" fill="#b45309">SITE BOOT</text>
        <text x="385" y="49" textAnchor="middle" fill="#b45309" fontSize="10">tiles + floor lock</text>
        <rect x="100" y="100" width="180" height="40" fill="#0a0a0a" />
        <text x="190" y="116" textAnchor="middle" fontWeight="600" fill="#fff">setSite / setLot</text>
        <text x="190" y="131" textAnchor="middle" fill="#a3a3a3" fontSize="10" fontFamily="JetBrains Mono">page useState</text>
        <rect x="320" y="180" width="160" height="40" fill="#fff" stroke="#0a0a0a" />
        <text x="400" y="196" textAnchor="middle" fontWeight="600">googleMapsSite</text>
        <text x="400" y="211" textAnchor="middle" fill="#737373" fontSize="10">geocode · elev</text>
        <rect x="500" y="180" width="160" height="40" fill="#fff" stroke="#0a0a0a" />
        <text x="580" y="196" textAnchor="middle" fontWeight="600">photorealisticFloor</text>
        <text x="580" y="211" textAnchor="middle" fill="#737373" fontSize="10">→ floorY</text>
        <rect x="500" y="270" width="180" height="40" fill="#eff6ff" stroke="#1d4ed8" />
        <text x="590" y="286" textAnchor="middle" fontWeight="600" fill="#1d4ed8">SitePlannerViewer</text>
        <text x="590" y="301" textAnchor="middle" fill="#1d4ed8" fontSize="10" opacity="0.75">R3F · tiles · lot</text>
        <rect x="700" y="270" width="170" height="40" fill="#eff6ff" stroke="#1d4ed8" />
        <text x="785" y="286" textAnchor="middle" fontWeight="600" fill="#1d4ed8">AduInstance</text>
        <text x="785" y="301" textAnchor="middle" fill="#1d4ed8" fontSize="10" opacity="0.75">useGLTF</text>
        <rect x="900" y="18" width="160" height="40" fill="#fff" stroke="#0a0a0a" />
        <text x="980" y="34" textAnchor="middle" fontWeight="600">Place · Add ADU</text>
        <text x="980" y="49" textAnchor="middle" fill="#737373" fontSize="10">catalog · gizmo</text>
        <rect x="900" y="100" width="160" height="40" fill="#0a0a0a" />
        <text x="980" y="116" textAnchor="middle" fontWeight="600" fill="#fff">setStructures</text>
        <text x="980" y="131" textAnchor="middle" fill="#a3a3a3" fontSize="10" fontFamily="JetBrains Mono">page useState</text>
        <rect x="900" y="450" width="180" height="40" fill="#ecfdf5" stroke="#047857" />
        <text x="990" y="466" textAnchor="middle" fontWeight="600" fill="#047857">speckleLiveSync</text>
        <text x="990" y="481" textAnchor="middle" fill="#047857" fontSize="10" opacity="0.7">optional</text>
        <rect x="1100" y="450" width="80" height="40" fill="#ecfdf5" stroke="#047857" />
        <text x="1140" y="466" textAnchor="middle" fontWeight="600" fill="#047857">Speckle</text>
        <text x="1140" y="481" textAnchor="middle" fill="#047857" fontSize="10" opacity="0.7">GraphQL</text>
      </g>
      <g fill="none" stroke="#0a0a0a" strokeWidth="1.2" markerEnd="url(#cmp-b)">
        <path d="M185,58 L185,100" />
        <path d="M190,140 L190,160 L400,180" />
        <path d="M480,200 L500,200" />
        <path d="M980,58 L980,100" />
      </g>
      <g fill="none" stroke="#1d4ed8" strokeWidth="1.2" markerEnd="url(#cmp-b-blue)">
        <path d="M580,220 L580,270" />
        <path d="M680,290 L700,290" />
        <path d="M980,140 L980,200 L785,270" />
      </g>
      <g fill="none" stroke="#047857" strokeWidth="1.2" markerEnd="url(#cmp-b-g)" strokeDasharray="4 3">
        <path d="M980,140 L980,450" />
        <path d="M1080,470 L1100,470" />
      </g>
    </svg>
  );
}

function Node({ solid, speckle, r3f, dashed, title, sub }) {
  const cls = ['node', solid && 'solid', speckle && 'speckle', r3f && 'r3f', dashed && 'dashed']
    .filter(Boolean)
    .join(' ');
  return (
    <div className={cls}>
      <b>{title}</b>
      <small>{sub}</small>
    </div>
  );
}

export default function XlabsCompare() {
  const topbarRef = useRef(null);
  const [topbarH, setTopbarH] = useState(88);

  useEffect(() => {
    const el = topbarRef.current;
    if (!el) return undefined;
    const sync = () => setTopbarH(el.getBoundingClientRect().height);
    sync();
    const ro = new ResizeObserver(sync);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return (
    <div className="xlabs-cmp" style={{ '--topbar-h': `${topbarH}px` }}>
      <Helmet>
        <title>xlabs · side-by-side architecture compare</title>
        <meta
          name="description"
          content="Side-by-side xlabs design vs Construx /viewer with highlighted diffs on shared design choices."
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter+Tight:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap"
          rel="stylesheet"
        />
      </Helmet>

      <div className="topbar" ref={topbarRef}>
        <div>
          <div className="topbar-title">xlabs · side-by-side compare</div>
          <div className="topbar-sub">
            A · design target ‖ B · Construx as built — amber = same concern, different choice
          </div>
        </div>
        <div className="topbar-actions">
          <Link to="/xlabs">Stacked view</Link>
          <Link to="/xlabs/speckle-case">$99 case</Link>
          <Link className="primary" to="/viewer">
            Open /viewer →
          </Link>
        </div>
        <div className="legend">
          <span className="legend-pill">
            <span className="legend-swatch" aria-hidden="true" />
            Diff
          </span>
          <span>Shared design axis, divergent choice — framework, state, Speckle role, render, journey, assets, latency, adapter</span>
          <span>Unmarked = unique to one side or aligned in spirit</span>
        </div>
      </div>

      <div className="col-heads">
        <div className="col-head a">
          <span className="tag">design target</span>
          <span className="letter">A</span>
          <b>xlabs · Speckle configurator</b>
          <small>Next.js · Redux · Speckle commit backbone</small>
        </div>
        <div className="col-head b">
          <span className="tag">as built</span>
          <span className="letter">B</span>
          <b>Construx · /viewer</b>
          <small>CRA · page state · R3F product path</small>
        </div>
      </div>

      <div className="body">
        {/* 01 Premise */}
        <div className="row">
          <div className="row-label">
            <span className="num">01</span> Premise
          </div>
          <div className="cell">
            <Same axis="shared" text="3D is a projection of canonical state — meshes are not freely edited in the viewer." />
            <Diff
              axis="speckle role"
              choice="Speckle is on the critical path"
              note="Every patch → commit → viewer subscribe. Latency is a product feature (SYNC badge)."
            />
            <p>
              <strong>Why Speckle:</strong> versioning, multi-client sync, comments, federated AEC graph. UI never imports{' '}
              <span className="mono">@speckle/objects</span> — only the adapter does.
            </p>
          </div>
          <div className="cell">
            <Same axis="shared" text="3D is a projection of canonical state — R3F canvas is controlled by page state." />
            <Diff
              axis="speckle role"
              choice="Speckle is optional"
              note="Product path never needs Speckle. Stream mode or outbound live sync only."
            />
            <p>
              <strong>Why R3F-first:</strong> site tiles + SoftPlan GLBs must render without a Speckle round-trip. Speckle stays swappable for sync / stream demos.
            </p>
          </div>
        </div>

        {/* 02 Design axes */}
        <div className="row">
          <div className="row-label">
            <span className="num">02</span> Design axes · highlighted diffs
          </div>
          <div className="cell">
            <Diff axis="framework" choice="Next.js App Router" note="app/(configure)/[id] step routes" />
            <Diff axis="canonical state" choice="Redux Toolkit · projectSlice" note="uiSlice · derivedSlice · historySlice · speckleSlice" />
            <Diff axis="product render" choice="@speckle/viewer (+ R3F overlays)" note="Viewer loads Speckle commit objects" />
            <Diff axis="assets" choice="Descriptors → Speckle objects" note="generateDescriptors() on every patch" />
            <Diff axis="latency signal" choice="SYNC · Speckle RTT" note="Honest round-trip on every commit" />
            <Diff axis="adapter" choice="SpeckleAdapter · patch ↔ commit" note="120ms debounce → 1 commit" />
          </div>
          <div className="cell">
            <Diff axis="framework" choice="CRA React 18 · react-router" note="/viewer · ?mode=site|model|speckle" />
            <Diff axis="canonical state" choice="page useState on SpeckleViewerPage" note="site · lot · structures · floorY · plannerStage" />
            <Diff axis="product render" choice="R3F SitePlannerViewer + tiles + GLB" note="Viewer.js only for ?mode=speckle" />
            <Diff axis="assets" choice="SoftPlan → GLB offline · Google tiles" note="static /models/*.glb at runtime" />
            <Diff axis="latency signal" choice="SITE BOOT · tiles + floor lock" note="Global overlay until Photorealistic seated" />
            <Diff axis="adapter" choice="speckleLiveSync + Viewer.js" note="Outbound versions · ~500ms debounce · not on edit path" />
          </div>
        </div>

        {/* 03 Layers */}
        <div className="row">
          <div className="row-label">
            <span className="num">03</span> Layered architecture
          </div>
          <div className="cell">
            <div className="layers">
              <div className="layer">
                <div className="layer-label">
                  <b>L0 · UI</b>
                  Next.js
                </div>
                <div className="nodes">
                  <Node title="ConfiguratorShell" sub="step shell" />
                  <Node title="Locate→Build" sub="step routes" />
                </div>
              </div>
              <div className="layer diff-layer">
                <div className="layer-label">
                  <b>L1 · State</b>
                  Redux
                </div>
                <div className="nodes">
                  <Node solid title="projectSlice" sub="canonical truth" />
                  <Node title="speckleSlice" sub="stream · commits" />
                </div>
              </div>
              <div className="layer">
                <div className="layer-label">
                  <b>L2 · Domain</b>
                  pure TS
                </div>
                <div className="nodes">
                  <Node title="geometry/*" sub="descriptors" />
                  <Node title="constraints/*" sub="solver" />
                  <Node title="bom/*" sub="takeoff" />
                </div>
              </div>
              <div className="layer diff-layer">
                <div className="layer-label">
                  <b>L3 · Adapters</b>
                  I/O
                </div>
                <div className="nodes">
                  <Node speckle title="SpeckleAdapter" sub="patch ↔ commit" />
                  <Node title="PersistenceAdapter" sub="/api/projects" />
                </div>
              </div>
              <div className="layer diff-layer">
                <div className="layer-label">
                  <b>L4 · Render</b>
                  Three
                </div>
                <div className="nodes">
                  <Node speckle title="SpeckleViewer" sub="@speckle/viewer" />
                  <Node title="R3F overlay" sub="dimensions" />
                </div>
              </div>
              <div className="layer diff-layer">
                <div className="layer-label">
                  <b>L5 · Backend</b>
                  Speckle
                </div>
                <div className="nodes">
                  <Node speckle title="Stream" sub="project graph" />
                  <Node speckle title="Commits" sub="versioned" />
                  <Node speckle title="Subscriptions" sub="graphql ws" />
                </div>
              </div>
            </div>
          </div>
          <div className="cell">
            <div className="layers">
              <div className="layer">
                <div className="layer-label">
                  <b>L0 · UI</b>
                  CRA
                </div>
                <div className="nodes">
                  <Node title="SpeckleViewerPage" sub="/viewer" />
                  <Node title="ViewerChrome" sub="stages · rail" />
                </div>
              </div>
              <div className="layer diff-layer">
                <div className="layer-label">
                  <b>L1 · State</b>
                  useState
                </div>
                <div className="nodes">
                  <Node solid title="site · lot · structures" sub="canonical truth" />
                  <Node title="liveSync*" sub="optional" />
                </div>
              </div>
              <div className="layer">
                <div className="layer-label">
                  <b>L2 · Domain</b>
                  catalog
                </div>
                <div className="nodes">
                  <Node title="sitePlannerCatalog" sub="SKUs" />
                  <Node title="softplanExamples" sub="sp-*" />
                </div>
              </div>
              <div className="layer diff-layer">
                <div className="layer-label">
                  <b>L3 · Adapters</b>
                  I/O
                </div>
                <div className="nodes">
                  <Node title="googleMapsSite" sub="geocode" />
                  <Node speckle title="speckleLiveSync" sub="optional out" />
                  <Node dashed title="softplan-web3d" sub="offline" />
                </div>
              </div>
              <div className="layer diff-layer">
                <div className="layer-label">
                  <b>L4 · Render</b>
                  Three
                </div>
                <div className="nodes">
                  <Node r3f title="SitePlannerViewer" sub="R3F · product" />
                  <Node r3f title="PhotorealisticTiles" sub="3d-tiles" />
                  <Node speckle title="Viewer.js" sub="stream only" />
                </div>
              </div>
              <div className="layer diff-layer">
                <div className="layer-label">
                  <b>L5 · Externals</b>
                  multi
                </div>
                <div className="nodes">
                  <Node title="Google Maps" sub="tiles · elev" />
                  <Node speckle title="Speckle" sub="optional" />
                  <Node title="/models/*.glb" sub="static" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 04 Dataflow */}
        <div className="row">
          <div className="row-label">
            <span className="num">04</span> Dataflow
          </div>
          <div className="cell">
            <p className="flow-note">
              <span className="diff-label">Diff</span> Speckle on the critical path — slider → patch → commit → viewer.
            </p>
            <div className="flow-wrap">
              <XlabsFlow />
            </div>
          </div>
          <div className="cell">
            <p className="flow-note">
              <span className="diff-label">Diff</span> Solid path is page state → R3F. Speckle (green dashed) is optional outbound.
            </p>
            <div className="flow-wrap">
              <ConstruxFlow />
            </div>
          </div>
        </div>

        {/* 05 Speckle contract */}
        <div className="row">
          <div className="row-label">
            <span className="num">05</span> Speckle surface
          </div>
          <div className="cell">
            <Diff
              axis="adapter contract"
              choice="commitPatch is the edit pipeline"
              note="Debounce 120ms · collapses slider drags to one commit"
            />
            <table className="contract">
              <thead>
                <tr>
                  <th>Surface</th>
                  <th>Dir</th>
                  <th>Payload</th>
                </tr>
              </thead>
              <tbody>
                <tr className="diff-row">
                  <td className="k">commitPatch</td>
                  <td>↗</td>
                  <td>patches → 1 commit</td>
                </tr>
                <tr>
                  <td className="k">connect</td>
                  <td>↗</td>
                  <td>viewer + ws</td>
                </tr>
                <tr>
                  <td className="k">onLatency</td>
                  <td>↘</td>
                  <td>SYNC badge</td>
                </tr>
                <tr>
                  <td className="k">onSelectionChanged</td>
                  <td>↘</td>
                  <td>uiSlice.selectedIds</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="cell">
            <Diff
              axis="adapter contract"
              choice="pushLiveVersion is optional outbound"
              note="Edit path never calls Speckle · ~500ms debounce when enabled"
            />
            <table className="contract">
              <thead>
                <tr>
                  <th>Surface</th>
                  <th>Dir</th>
                  <th>Payload</th>
                </tr>
              </thead>
              <tbody>
                <tr className="diff-row">
                  <td className="k">pushLiveVersion</td>
                  <td>↗</td>
                  <td>lot + ADUs → version</td>
                </tr>
                <tr>
                  <td className="k">loadObject</td>
                  <td>↗</td>
                  <td>stream mode only</td>
                </tr>
                <tr>
                  <td className="k">createLiveSyncScheduler</td>
                  <td>↔</td>
                  <td>debounce → push</td>
                </tr>
                <tr>
                  <td className="k">version URL</td>
                  <td>↘</td>
                  <td>Tools · Open Speckle</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* 06 Journey */}
        <div className="row">
          <div className="row-label">
            <span className="num">06</span> Journey
          </div>
          <div className="cell">
            <p className="flow-note">
              <span className="diff-label">Diff</span> Locate → Design → Analyse → Build under <span className="mono">/configure/[id]</span>
            </p>
            <ol className="steps">
              <li className="diff-step">
                <b>Locate</b>
                Mapbox polygon · setbacks · orientation
              </li>
              <li className="diff-step">
                <b>Design</b>
                Parametric edits · Speckle commits on main
              </li>
              <li className="diff-step">
                <b>Analyse</b>
                Cost / carbon / span overlays · read-only
              </li>
              <li className="diff-step">
                <b>Build</b>
                BOM · panelization · export jobs
              </li>
            </ol>
          </div>
          <div className="cell">
            <p className="flow-note">
              <span className="diff-label">Diff</span> Site → Place → Inspect → Next on <span className="mono">/viewer</span>
            </p>
            <ol className="steps">
              <li className="diff-step">
                <b>Site</b>
                Address · Photorealistic tiles · floor lock · lot
              </li>
              <li className="diff-step">
                <b>Place</b>
                Catalog ADU · PivotControls · GLB instances
              </li>
              <li className="diff-step">
                <b>Inspect</b>
                Layers · vertical section clip
              </li>
              <li className="diff-step">
                <b>Next</b>
                Handoff CTA · Speckle behind Tools
              </li>
            </ol>
          </div>
        </div>

        {/* 07 Directory */}
        <div className="row">
          <div className="row-label">
            <span className="num">07</span> Directory sketch
          </div>
          <div className="cell">
            <div className="dir">
              <div className="dir-block">
                <h4>app/ · components/ · lib/</h4>
                <dl>
                  <dt>(configure)/[id]/page.tsx</dt>
                  <dd>Shell + step router</dd>
                  <dt>canvas/Viewer.tsx</dt>
                  <dd>Speckle viewer host</dd>
                  <dt>lib/speckle/adapter.ts</dt>
                  <dd>Patch ↔ commit</dd>
                  <dt>lib/store/</dt>
                  <dd>RTK slices</dd>
                </dl>
              </div>
            </div>
          </div>
          <div className="cell">
            <div className="dir">
              <div className="dir-block">
                <h4>src/ · tools/ · docs/</h4>
                <dl>
                  <dt>Pages/SpeckleViewerPage.js</dt>
                  <dd>State + mode shell</dd>
                  <dt>Viewer/SitePlannerViewer.js</dt>
                  <dd>R3F product scene</dd>
                  <dt>services/speckleLiveSync.js</dt>
                  <dd>Optional outbound</dd>
                  <dt>tools/softplan-web3d/</dt>
                  <dd>.dat → OBJ → GLB</dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
